// Parent component to demonstrate ModularForm usage
import React, { useState } from 'react';
import ModularForm from './ModularForm';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import StarIcon from "@mui/icons-material/Star";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// Sample JSON data for demonstration
const sampleData2 = {
  sections: [
    {
      title: 'Personal Details',
      fields: [
        { name: 'firstName', type: 'text', label: 'First Name', rules: ['required'], gridSize: 6 },
        { name: 'lastName', type: 'text', label: 'Last Name', rules: ['required'], gridSize: 6 },
        { name: 'email', type: 'text', label: 'Email', rules: ['email'], gridSize: 12 }
      ]
    },
    {
      title: 'Preferences',
      fields: [
        {
          name: 'color',
          type: 'select',
          label: 'Favorite Color',
          options: [
            { label: 'Red', value: 'red' },
            { label: 'Blue', value: 'blue' },
            { label: 'Green', value: 'green' }
          ],
          rules: ['required'],
          gridSize: 6
        },
        { name: 'newsletter', type: 'toggle', label: 'Subscribe to Newsletter', gridSize: 6 }
      ]
    },
    {
      title: 'Additional Info',
      fields: [
        { name: 'birthDate', type: 'date', label: 'Birth Date', rules: ['required'], gridSize: 6 },
        { name: 'resume', type: 'file', label: 'Upload Resume', rules: ['required'], gridSize: 6, multiple: false }
      ]
    }
  ]
};

const ParentComponent = () => {
 const sampleData = {
   sections: [
     {
       title: 'Personal Details',
       fields: [
         { name: 'firstName', type: 'text', label: 'First Name', rules: ['required'], gridSize: 6 },
         { name: 'lastName', type: 'text', label: 'Last Name', rules: ['required'], gridSize: 6 },
         { name: 'email', type: 'text', label: 'Email', rules: ['email', 'required'], gridSize: 12 },
         { name: 'bio', type: 'textarea', label: 'Biography', gridSize: 12, rules: [] }
       ]
     },
     {
       title: 'Preferences',
       fields: [
         {
           name: 'color',
           type: 'select',
           label: 'Favorite Color',
           options: [
             { label: 'Red', value: 'red' },
             { label: 'Blue', value: 'blue' },
             { label: 'Green', value: 'green' },
             { label: 'Yellow', value: 'yellow' }
           ],
           rules: ['required'],
           gridSize: 6
         },
         { name: 'newsletter', type: 'toggle', label: 'Subscribe to Newsletter', gridSize: 6 },
         {
           name: 'contactMethod',
           type: 'radio',
           label: 'Preferred Contact Method',
           options: [
             { label: 'Email', value: 'email' },
             { label: 'Phone', value: 'phone' }
           ],
           gridSize: 12
         }
       ]
     },
     {
       title: 'Additional Info',
       fields: [
         { name: 'birthDate', type: 'date', label: 'Birth Date', rules: ['required'], gridSize: 6 },
         { name: 'appointmentTime', type: 'time', label: 'Preferred Appointment Time', rules: [], gridSize: 6 },
         {
           name: "availability",
           type: "daterange",
           label: "Availability Range",
           rules: ["required"],
           gridSize: 8
         },
         { name: 'resume', type: 'file', label: 'Upload Resume', rules: ['required'], gridSize: 6, multiple: false },
         { name: 'portfolio', type: 'file', label: 'Upload Portfolio', gridSize: 6, multiple: true }
       ]
     },
     {
       title: 'Signature and Agreement',
       fields: [
         { "name": "signature", "type": "signature", "label": "Your Signature", "rules": ["required"], "gridSize": 12 },
         {
           name: 'terms',
           type: 'checkbox',
           label: 'I agree to the terms and conditions',
           rules: ['required'],
           gridSize: 12
         },
         {
          name: 'autoSelectExample',
          type: 'autoselect',
          label: 'Choose an Option',
          options: [
            {
              label: 'Option 1',
              value: 'option1',
              icon: <StarIcon /> // תחליף לסמל מותאם אישית
            },
            {
              label: 'Option 2',
              value: 'option2',
              icon: <CheckCircleIcon /> // סמל מותאם אישית נוסף
            },
            {
              label: 'Option 3',
              value: 'option3' // אפשר גם בלי סמל
            }
          ], // ערכים שנבנו קודם
          rules: ['required'], // אם נדרשת בדיקת חובה
          gridSize: 6 // גודל התצוגה של השדה
        }
       ]
     },
   ]
 };
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleFormSubmit = async (formData) => {
    console.log('Submitted Data:', formData);
    // Simulate a server request
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log('Data submitted successfully');
        resolve(true);
      }, 2000);
    });
  };

  return (
    <div style={{ padding: '20px' }}>
      {/* Trigger button for popup */}
      <Button variant="contained" color="primary" onClick={() => setIsPopupOpen(true)}>
        Open Form in Popup
      </Button>

      {/* Modular form in full screen */}
      <div style={{ marginTop: '20px' }}>
        <h2>Form in Full Screen</h2>
        <ModularForm 
        sections={sampleData.sections} onSubmit={handleFormSubmit} isPopup={false} trackUpdates={true} enableCollapse={true} />
      </div>

      {/* Popup for Modular Form */}
      <Dialog open={isPopupOpen} onClose={() => setIsPopupOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Form in Popup</DialogTitle>
        <DialogContent>
          <ModularForm
            sections={sampleData.sections}
            onSubmit={async (data) => {
              const success = await handleFormSubmit(data);
              if (success) setIsPopupOpen(false);
            }}
            isPopup={true}
            trackUpdates={true}
            enableCollapse={false}
           
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsPopupOpen(false)} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ParentComponent;
